<template>
  <div>
    <icon-view
      class="mr-2 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-file color-orange mb-1"
      title="Sección de Guía(s) de Usuario"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <custom-callout
      v-for="(item, index) in model"
      :key="index"
      class-main=" mt-3 border-0 py-3"
      :has-border="false"
      :has-gradient="false"
      :has-toggle="false"
    >
      <div class="row mr-md-0">
        <div class="col col-sm-3">
          <div class="color-gray-6 font-14">Nombre de la Guía de Usuario:</div>
          <div class="color-black font-16">
            {{ item.name }}
          </div>
        </div>
        <div class="col col-sm">
          <div class="color-gray-6 font-14">Archivo:</div>
          <div class="d-flex align-items-center w-100 ">
            <div class="font-weight-normal">
              <label class="circle-green"></label>
              <label class="mb-0">{{ item.file.name }}</label>
            </div>
            <div class="d-flex flex-row-reverse ml-2 button-container">
              <button
                type="button"
                class="btn outline-success mr-2 ml-2"
                @click="downloadFile(item.file)"
              >
                <i class="fas fa-file-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col col-sm text-sm-right mt-3 mt-sm-1">
          <action-button
            i="fas fa-times-circle mr-n1 pr-1"
            variant="outline-danger"
            :disabled="readOnly"
            v-if="!readOnly"
            @click="remove(index)"
          />
        </div>
      </div>
    </custom-callout>
    <div class="col-12 text-right mt-3 mx-0 px-0" v-if="!showAdd">
      <action-button
        type="button"
        text="Añadir"
        i="fas fa-file-plus"
        variant="success"
        v-if="!readOnly"
        :disabled="readOnly"
        @click="showAdd = true"
        class="ml-2 px-4 mb-3 actionButton"
      />
    </div>
    <div class="row" v-if="showAdd && !readOnly">
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded px-2 pt-2"
          :has-border="false"
          :has-toggle="false"
        >
          <validation-observer ref="userGuideValidator">
            <div class="row">
              <div class="col-4">
                <span class="data-title d-block">
                  Nombre de Guía de Usuario:
                </span>
                <validation-provider
                  ref="name"
                  v-slot="{ errors }"
                  :rules="{ required: !avoidRequired }"
                >
                  <custom-input
                    :error="errors[0]"
                    custom-error-msg="Este campo es requerido."
                    v-model="current.name"
                    :disabled="readOnly"
                  />
                </validation-provider>
              </div>
              <div class="col-4">
                <span class="data-title d-block">
                  Archivo
                </span>
                <validation-provider
                  ref="file"
                  v-slot="{ errors }"
                  :rules="{ required: !avoidRequired }"
                >
                  <custom-file-input
                    ref="fileUpload"
                    display-style="normal"
                    accept=".pdf"
                    label-position="left"
                    addText="Presione aquí para anejar guía de usuario"
                    custom-error-msg="La guía de usuario es requerida."
                    :error="errors[0]"
                    :on-download="downloadFile"
                    :disabled="readOnly"
                    v-model="current.file"
                    :max-size="maxGuideConfigFileSizeInMb"
                  />
                </validation-provider>
              </div>
              <div
                class="col-md-4 mt-3 mt-md-0 col-4 d-flex justify-content-end align-items-center px-0"
              >
                <div class="p-4 mt-1">
                  <action-button
                    type="button"
                    text="Cancelar"
                    i="fa fa-times-circle"
                    variant="outline-danger"
                    class="ml-2 px-4 mb-3 actionButton"
                    :disabled="readOnly"
                    @click="clear()"
                  />
                  <action-button
                    type="button"
                    text="Guardar"
                    i="fas fa-save"
                    variant="success"
                    class="ml-2 px-4 mb-3 actionButton"
                    :disabled="readOnly"
                    @click="add()"
                  />
                </div>
              </div>
            </div>
          </validation-observer>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import IconView from 'icon-view';
import CustomCallout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import generalService from '@/services/pei/general';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';

export default {
  name: 'UserGuideSection',
  components: {
    IconView,
    CustomCallout,
    CustomFileInput,
    ActionButton,
    CustomInput,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    avoidRequired: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      current: {
        name: null,
        file: null,
      },
      showAdd: true,
      maxGuideConfigFileSizeInMb: 10,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  mounted() {
    this.showAdd = !this.model.length;
    this.getSysParams();
  },
  methods: {
    async clear() {
      this.current = { name: null, file: null };
      if (this.model.length > 0) {
        this.showAdd = false;
      }
      await this.$refs.userGuideValidator.reset();
    },
    async add() {
      let valid = await this.$refs.userGuideValidator.validate();
      if (!valid) return;
      if (!this.current.name) {
        valid = false;
        await this.$refs.name.validate('');
      }
      if (!this.current.file) {
        valid = false;
        await this.$refs.file.validate('');
      }
      if (!valid) return;

      this.$emit('add', this.current);
      this.current = { name: null, file: null };
      this.showAdd = false;
      await this.$refs.userGuideValidator.reset();
    },
    remove(index) {
      if (this.readOnly) return;
      if (this.model.length === 1) {
        this.showAdd = true;
      }
      this.$emit('remove', index);
    },
    downloadFile(item) {
      const isFile = item && item instanceof File;
      if (isFile) generalService.documentDownloadLocalFile(item);
      else generalService.getDocument(item.id);
    },
    async getSysParams() {
      const paramValue = (
        await getSysparameterByNames({
          parameterNames: ['AcademicMaxGuideConfigFileSizeInMb'],
        })
      )?.data[0]?.staticValue;
      if (paramValue) {
        this.maxGuideConfigFileSizeInMb = +paramValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .justify-content-start {
  justify-content: center !important;
  margin-bottom: 1rem;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}

::v-deep .btn-action-size > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}

.file-select {
  text-align: center;
  margin-bottom: 0px !important;
}

input[type='file'] {
  display: none;
}

.success {
  color: #ffffff;
  background-color: #2db782;
  border-color: #2db782;
}

.outline-success {
  color: #2db782;
  background-color: #ffffff;
  border-color: #2db782;
}

.danger {
  color: #ffffff;
  background-color: #c9545e;
  border-color: #c9545e;
}

.outline-danger {
  color: #c9545e;
  background-color: #ffffff;
  border-color: #c9545e;
}
.outline-danger:hover {
  background-color: #c9545e;
  color: #ffffff;
}
.outline-success:hover {
  background-color: #2db782;
  color: #ffffff;
}

.input-disabled {
  background-color: #e9ecef;
  cursor: initial;
}

.button-container button {
  height: 33px;
  width: 33px;
  padding: 0;
}

.file-input-container {
  height: auto !important;
}
</style>
